<div class="ps-xsmall-b flex">
  <span class="nowrap ms-xxsmall-r">{{ count() }} x</span>
  @if (icon()) {
    <fcom-icon [name]="icon()" class="ms-xxsmall-r flex--shrink0"></fcom-icon>
  }
  <span class="flex-1 truncate overflow-hidden">
    @if (title()) {
      {{ title() }}
    } @else if (titleKey()) {
      {{ titleKey() | finLocalization: titleParams() }}
    }
  </span>
  <!-- TODO: remove heather-800-text after the brand renewal; text-icon-accent is its new-brand replacement -->
  <span class="nowrap ps-small-l" [class.heather-800-text]="isBundle()" [class.text-icon-accent]="isBundle()">{{
    price() | finPrice
  }}</span>
</div>
@for (child of childRows(); track child.titleKey ?? child.title ?? $index) {
  <div class="ps-xsmall-b ps-large-l flex">
    <span class="nowrap ms-xxsmall-r">{{ child.count }} x</span>
    <span class="flex-1 truncate overflow-hidden">
      @if (child.title) {
        {{ child.title }}
      } @else if (child.titleKey) {
        {{ child.titleKey | finLocalization: child.titleParams }}
      }
    </span>
  </div>
}
